import { Turbo } from "@hotwired/turbo-rails";

// Expose for app code that calls Turbo.visit() (timer, global search).
// turbo-rails also assigns window.Turbo; keep an explicit assignment for clarity.
window.Turbo = Turbo;

// リンクの hover prefetch は <meta name="turbo-prefetch" content="false"> で無効化している。

// GET search forms keep full page navigation.
// Turbo Drive visits on complex index/search pages race with Select2/AdminLTE re-init.
// turbo-frame 配下 / frame ターゲットのフォームは対象外。フレーム更新まで殺してしまう。
function optOutGetForm(form) {
  if (!form || !form.getAttribute) return;
  if (form.hasAttribute("data-turbo")) return;
  if (form.hasAttribute("data-turbo-frame")) return;
  if (form.closest && form.closest("turbo-frame")) return;
  var method = (form.getAttribute("method") || "get").toLowerCase();
  if (method === "get") {
    form.setAttribute("data-turbo", "false");
  }
}

function optOutGetForms(root) {
  if (!root || !root.querySelectorAll) return;
  root.querySelectorAll("form").forEach(optOutGetForm);
}

optOutGetForms(document);
document.addEventListener("turbo:load", function () {
  optOutGetForms(document);
});

document.addEventListener(
  "submit",
  function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    if (form.hasAttribute("data-turbo")) return;
    // 走査に載らなかった GET フォーム (モーダル等で後から挿入されたもの) もここで拾う。
    optOutGetForm(form);
  },
  true
);

// Turbo fires turbo:render but not turbo:load after 4xx/5xx form responses.
// Existing page scripts still listen for turbo:load (ex-turbolinks:load).
// Track in-flight form submissions via submit-start/end so a concurrent GET
// cannot clobber the flag between request and response.
var formSubmissionInFlight = false;
var synthesizeLoadAfterErrorRender = false;

document.addEventListener("turbo:submit-start", function () {
  formSubmissionInFlight = true;
});
document.addEventListener("turbo:submit-end", function () {
  formSubmissionInFlight = false;
});

document.addEventListener("turbo:before-fetch-response", function (event) {
  var fetchResponse = event.detail && event.detail.fetchResponse;
  var statusCode = fetchResponse && fetchResponse.statusCode;
  synthesizeLoadAfterErrorRender = formSubmissionInFlight && statusCode >= 400;
});

// 4xx でも turbo:render に至らない経路 (turbo-stream 応答、frame ターゲットのフォーム、
// body 無し応答) があり、フラグが立ちっぱなしになると後続の turbo:render で
// 偽の turbo:load が飛んで二重初期化になる。次の遷移が始まる前に必ず落とす。
// Turbo 8 のフォームエラー再描画は Navigator#formSubmissionFailedWithResponse から
// View#renderPage を直接呼ぶ経路で、下記 3 イベントはいずれも間に挟まらない。
function clearSynthesizeFlag() {
  synthesizeLoadAfterErrorRender = false;
}
document.addEventListener("turbo:before-fetch-request", clearSynthesizeFlag);
document.addEventListener("turbo:before-cache", clearSynthesizeFlag);
document.addEventListener("turbo:load", clearSynthesizeFlag);

document.addEventListener("turbo:render", function () {
  if (!synthesizeLoadAfterErrorRender) return;
  if (document.documentElement.hasAttribute("data-turbo-preview")) return;
  synthesizeLoadAfterErrorRender = false;

  document.dispatchEvent(
    new CustomEvent("turbo:load", {
      bubbles: true,
      // 本物の turbo:load は {url, timing} を持つので形を揃える。
      detail: { url: window.location.href, timing: {} }
    })
  );
});
